import { SingleSelectionValidator } from '../validator';
import { RatingView } from '../view';
import { SingleSelectionConfigurator } from './single-selection';

export class RatingConfigurator extends SingleSelectionConfigurator {
  constructor({
    serverContext, configuration, i18n, surveyConfigurator,
  }) {
    super({
      serverContext, configuration, i18n, surveyConfigurator,
    });
    this.setOptionKeyToRating();
  }

  get view() {
    return RatingView;
  }

  initValidator() {
    this.validator = new SingleSelectionValidator();
  }

  setOptionKeyToRating() {
    const { options } = this.configuration;
    this.optionKeyToRating = {};
    options.forEach((option) => {
      this.optionKeyToRating[option.key] = option.rating;
    });
  }

  getDefaultData(): Object {
    return {
      selectedOption: undefined,
      ...this.data,
    };
  }

  getDefaultDirtyState(bool): Object {
    const state = {
      isDirty: bool,
    };
    const { options } = this.configuration;
    options.forEach((option) => {
      const { key } = option;
      state[key] = bool;
    });
    return state;
  }

  getFeedbackData(answers: any): any {
    const data = answers[this.key];
    const { options } = this.configuration;
    if (data.selectedOption) {
      return {
        rating: parseFloat(this.optionKeyToRating[data.selectedOption]),
        ratingOptionsCount: options.length,
      };
    }
    return null;
  }
}
